/* eslint-disable @typescript-eslint/naming-convention */
import type { TextStyle } from '@studiobuki/web-core/lib/book-common';

export const KozGoProRegular_ffffff_31: TextStyle = {
  fill: '#ffffff',
  fontFamily: 'KozGoProRegular',
  fontSize: 31,
  letterSpacing: 1,
  lineHeight: 1.5,
};
export const AFSSerifGothic04trialE_ffffff_21: TextStyle = {
  fill: '#ffffff',
  fontFamily: 'AFSSerifGothic04trialE',
  fontSize: 21,
  letterSpacing: 1,
  lineHeight: 1.5,
};
export const AFSSerifGothic04trialE_ffffff_31: TextStyle = {
  fill: '#ffffff',
  fontFamily: 'AFSSerifGothic04trialE',
  fontSize: 31,
  letterSpacing: 1,
  lineHeight: 1.5,
};
export const ZenMaruGothicBlack_645542_60: TextStyle = {
  fill: '#645542',
  fontFamily: 'ZenMaruGothicBlack',
  fontSize: 60,
  letterSpacing: 9,
  lineHeight: 1.5,
};
export const APJapanesefont_000000_18: TextStyle = {
  fill: '#000000',
  fontFamily: 'APJapanesefont',
  fontSize: 18,
  letterSpacing: 1,
  lineHeight: 1.5,
};
export const APJapanesefont_000000_21: TextStyle = {
  fill: '#000000',
  fontFamily: 'APJapanesefont',
  fontSize: 21,
  letterSpacing: 1,
  lineHeight: 1.5,
};
export const APJapanesefont_000000_24: TextStyle = {
  fill: '#000000',
  fontFamily: 'APJapanesefont',
  fontSize: 24,
  letterSpacing: 1,
  lineHeight: 1.5,
};
export const APJapanesefont_000000_23: TextStyle = {
  fill: '#000000',
  fontFamily: 'APJapanesefont',
  fontSize: 23,
  letterSpacing: 1,
  lineHeight: 1.5,
};
export const APJapanesefont_000000_30: TextStyle = {
  fill: '#000000',
  fontFamily: 'APJapanesefont',
  fontSize: 30,
  letterSpacing: 1,
  lineHeight: 1.5,
};
export const CorporateLogoRound_000000_8: TextStyle = {
  fill: '#000000',
  fontFamily: 'CorporateLogoRound',
  fontSize: 8,
  letterSpacing: 1,
  lineHeight: 1.5,
};
export const CorporateLogoRound_000000_12: TextStyle = {
  fill: '#FFFFFF',
  fontFamily: 'CorporateLogoRound',
  fontSize: 12,
  letterSpacing: 1,
  lineHeight: 1.5,
};
